var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-create main-content" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitPaymentData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "page-header" }, [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(
              _vm._s(
                _vm.isEdit
                  ? _vm.$t("payments.edit_payment")
                  : _vm.$t("payments.new_payment")
              )
            ),
          ]),
          _vm._v(" "),
          _c("ol", { staticClass: "breadcrumb" }, [
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _vm.userType == "supplier"
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          slot: "item-title",
                          to: "/supplier/dashboard",
                        },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    )
                  : _vm.userType == "anchor"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/anchor/dashboard" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$t("general.home")))]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              { staticClass: "breadcrumb-item" },
              [
                _vm.userType == "supplier"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/supplier/payments" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$tc("payments.payment", 2)))]
                    )
                  : _vm.userType == "anchor"
                  ? _c(
                      "router-link",
                      {
                        attrs: { slot: "item-title", to: "/anchor/payments" },
                        slot: "item-title",
                      },
                      [_vm._v(_vm._s(_vm.$tc("payments.payment", 2)))]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("li", { staticClass: "breadcrumb-item" }, [
              _vm._v(
                _vm._s(
                  _vm.isEdit
                    ? _vm.$t("payments.edit_payment")
                    : _vm.$t("payments.new_payment")
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "page-actions row" }, [
            _c(
              "div",
              { staticClass: "col-xs-2 mr-4" },
              [
                _vm.formData.request_level == "Eligible" &&
                _vm.invoiceStatus == "SENT"
                  ? _c(
                      "base-button",
                      {
                        attrs: {
                          outline: true,
                          size: "large",
                          icon: "check",
                          color: "theme",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.saveNonFinanceInvoiceInfo()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("general.save")) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-2" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      size: "large",
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.isEdit
                            ? _vm.$t("payments.update_payment")
                            : _vm.$t("payments.register_payment")
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.formData.request_level == "Eligible" && _vm.invoiceStatus == "SENT"
          ? _c("div", { staticClass: "payment-card card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("payments.schedule_payment_date")) +
                              " "
                          ),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(" *"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("base-date-picker", {
                          attrs: {
                            "calendar-button": true,
                            "calendar-button-icon": "calendar",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.$v.nonFinanceInvoiceInfo.schedule_payment_date.$touch()
                            },
                          },
                          model: {
                            value:
                              _vm.nonFinanceInvoiceInfo.schedule_payment_date,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nonFinanceInvoiceInfo,
                                "schedule_payment_date",
                                $$v
                              )
                            },
                            expression:
                              "nonFinanceInvoiceInfo.schedule_payment_date",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(_vm._s(_vm.$t("payments.payment_code")) + " "),
                        ]),
                        _vm._v(" "),
                        _c("base-input", {
                          attrs: {
                            invalid:
                              _vm.$v.nonFinanceInvoiceInfo.payment_code.$error,
                            type: "text",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.$v.nonFinanceInvoiceInfo.payment_code.$touch()
                            },
                          },
                          model: {
                            value: _vm.nonFinanceInvoiceInfo.payment_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nonFinanceInvoiceInfo,
                                "payment_code",
                                $$v
                              )
                            },
                            expression: "nonFinanceInvoiceInfo.payment_code",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.nonFinanceInvoiceInfo.payment_code.$error
                          ? _c("div", [
                              !_vm.$v.nonFinanceInvoiceInfo.payment_code.numeric
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$tc("validation.numeric")) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("general.withholding_tax_rate"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "base-input" },
                        [
                          _c(
                            "money",
                            _vm._b(
                              {
                                staticClass: "input-field",
                                class: {
                                  invalid:
                                    _vm.$v.nonFinanceInvoiceInfo
                                      .income_tax_withholding.$error,
                                },
                                model: {
                                  value: _vm.income_tax_withholding,
                                  callback: function ($$v) {
                                    _vm.income_tax_withholding = $$v
                                  },
                                  expression: "income_tax_withholding",
                                },
                              },
                              "money",
                              _vm.defaultInputTax,
                              false
                            )
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$v.nonFinanceInvoiceInfo.income_tax_withholding.$error
                        ? _c("div", [
                            !_vm.$v.nonFinanceInvoiceInfo.income_tax_withholding
                              .between
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "form-group__message text-danger",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "validation.enter_valid_tax_rate"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(
                            _vm._s(_vm.$tc("payments.payment_type", 1)) + " "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("base-input", {
                          attrs: {
                            invalid:
                              _vm.$v.nonFinanceInvoiceInfo.payment_type.$error,
                            type: "text",
                          },
                          on: {
                            input: function ($event) {
                              return _vm.$v.nonFinanceInvoiceInfo.payment_type.$touch()
                            },
                          },
                          model: {
                            value: _vm.nonFinanceInvoiceInfo.payment_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nonFinanceInvoiceInfo,
                                "payment_type",
                                $$v
                              )
                            },
                            expression: "nonFinanceInvoiceInfo.payment_type",
                          },
                        }),
                        _vm._v(" "),
                        _vm.$v.nonFinanceInvoiceInfo.payment_type.$error
                          ? _c("div", [
                              !_vm.$v.nonFinanceInvoiceInfo.payment_type
                                .alphaNum
                                ? _c("span", { staticClass: "text-danger" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$tc("validation.alphaNum")) +
                                        "\n                "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formData.request_level == "Eligible" &&
        _vm.invoiceStatus == "AUTHORIZED"
          ? _c("div", { staticClass: "payment-card card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("payments.schedule_payment_date")) +
                              " "
                          ),
                          _c("span", { staticClass: "text-danger" }, [
                            _vm._v(" *"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("base-date-picker", {
                          attrs: {
                            "calendar-button": true,
                            "calendar-button-icon": "calendar",
                          },
                          model: {
                            value:
                              _vm.nonFinanceInvoiceInfo.schedule_payment_date,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.nonFinanceInvoiceInfo,
                                "schedule_payment_date",
                                $$v
                              )
                            },
                            expression:
                              "nonFinanceInvoiceInfo.schedule_payment_date",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(_vm._s(_vm.$t("payments.payment_code")) + " "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.nonFinanceInvoiceInfo.payment_code
                              ),
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "form-label" }, [
                        _vm._v(
                          _vm._s(_vm.$tc("payments.payment_type", 1)) + " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "base-read-box base-read-box-field" },
                        [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.nonFinanceInvoiceInfo.payment_type
                              ),
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "payment-card card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("payments.date"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-date-picker", {
                      attrs: {
                        invalid: _vm.$v.formData.payment_date.$error,
                        "calendar-button": true,
                        "calendar-button-icon": "calendar",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$v.formData.payment_date.$touch()
                        },
                      },
                      model: {
                        value: _vm.formData.payment_date,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "payment_date", $$v)
                        },
                        expression: "formData.payment_date",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.formData.payment_date.$error
                      ? _c("div", [
                          !_vm.$v.formData.payment_date.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.$t("validation.required"))),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("payments.reference_number"))),
                    ]),
                    _vm._v(" "),
                    _c("base-input", {
                      model: {
                        value: _vm.formData.referenceNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "referenceNumber", $$v)
                        },
                        expression: "formData.referenceNumber",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-6" },
                [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("payments.supplier"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c("base-select", {
                    attrs: {
                      options: _vm.userList,
                      searchable: true,
                      "show-labels": false,
                      "allow-empty": false,
                      disabled: _vm.isEdit,
                      placeholder: _vm.$t("suppliers.select_a_supplier"),
                      label: "name",
                      "track-by": "id",
                    },
                    model: {
                      value: _vm.user,
                      callback: function ($$v) {
                        _vm.user = $$v
                      },
                      expression: "user",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("payments.invoice"))),
                    ]),
                    _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                    _vm._v(" "),
                    _c("base-select", {
                      attrs: {
                        options: _vm.invoiceList,
                        invalid: _vm.$v.invoice.$error,
                        searchable: true,
                        "show-labels": false,
                        "allow-empty": false,
                        disabled: _vm.isEdit,
                        placeholder: _vm.$t("invoices.select_invoice"),
                        "custom-label": _vm.invoiceWithAmount,
                        "track-by": "id",
                      },
                      model: {
                        value: _vm.invoice,
                        callback: function ($$v) {
                          _vm.invoice = $$v
                        },
                        expression: "invoice",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.invoice.$error
                      ? _c("div", [
                          !_vm.$v.invoice.required
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(_vm._s(_vm.$tc("validation.required"))),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "form-label" }, [
                    _vm._v(_vm._s(_vm.$t("payments.amount"))),
                  ]),
                  _c("span", { staticClass: "text-danger" }, [_vm._v(" *")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-input" },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field",
                            class: { invalid: _vm.$v.formData.amount.$error },
                            model: {
                              value: _vm.amount,
                              callback: function ($$v) {
                                _vm.amount = $$v
                              },
                              expression: "amount",
                            },
                          },
                          "money",
                          _vm.paymentCurrency,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.$v.formData.amount.$error
                    ? _c("div", [
                        !_vm.$v.formData.amount.required
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(_vm._s(_vm.$t("validation.required"))),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.formData.amount.between &&
                        _vm.$v.formData.amount.numeric &&
                        _vm.formData.amount <= 0
                          ? _c("span", { staticClass: "text-danger" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("validation.payment_greater_than_zero")
                                )
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("payments.payment_mode"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "base-select",
                      {
                        attrs: {
                          options: _vm.paymentModes,
                          searchable: true,
                          "show-labels": false,
                          placeholder: _vm.$t("payments.select_payment_mode"),
                          label: "name",
                        },
                        model: {
                          value: _vm.formData.payment_method,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "payment_method", $$v)
                          },
                          expression: "formData.payment_method",
                        },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "afterList" }, slot: "afterList" },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "list-add-button",
                                attrs: { type: "button" },
                                on: { click: _vm.addPaymentMode },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "icon",
                                  attrs: { icon: "cart-plus" },
                                }),
                                _vm._v(" "),
                                _c("label", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "settings.customization.payments.add_payment_mode"
                                      )
                                    )
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12 " }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(_vm._s(_vm.$t("payments.note"))),
                    ]),
                    _vm._v(" "),
                    _c("base-text-area", {
                      on: {
                        input: function ($event) {
                          return _vm.$v.formData.notes.$touch()
                        },
                      },
                      model: {
                        value: _vm.formData.notes,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "notes", $$v)
                        },
                        expression: "formData.notes",
                      },
                    }),
                    _vm._v(" "),
                    _vm.$v.formData.notes.$error
                      ? _c("div", [
                          !_vm.$v.formData.notes.maxLength
                            ? _c("span", { staticClass: "text-danger" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("validation.notes_maxlength"))
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-12" }, [
                _c(
                  "div",
                  { staticClass: "form-group collapse-button-container" },
                  [
                    _c(
                      "base-button",
                      {
                        staticClass: "collapse-button",
                        attrs: {
                          loading: _vm.isLoading,
                          icon: "save",
                          color: "theme",
                          type: "submit",
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("payments.save_payment")) +
                            "\n              "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }